<template>
  <div class="home-faq pt-18">
    <SectionHeader class="automate-header max-w-4xl mx-auto">
      <template #header>
        <div class="mb-4">How does Bambee&nbsp;Work?</div>
      </template>
      <template #subheader> <div>Frequently Asked Questions</div> </template>
    </SectionHeader>
    <div class="faq-items-list max-w-4xl mx-auto py-18 px-6 sm:px-8">
      <template v-for="(item, index) in faqs">
        <FaqItem
          v-if="index < maxItems"
          :key="`faq-item-${index}`"
          v-bind="item"
          :show="show === index"
          @toggle="faqToggle(index)"
        />
      </template>
      <BaseButton
        v-if="maxItems === 5"
        :flat="true"
        class="block mx-auto my-4"
        @click="updateQty('max')"
      >
        Show More
      </BaseButton>
      <BaseButton
        v-else
        :flat="true"
        class="block mx-auto my-4"
        @click="updateQty('min')"
      >
        Show Less
      </BaseButton>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  nextTick,
  onMounted,
  ref,
  useFetch,
} from '@nuxtjs/composition-api';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { BaseButton } from '@bambeehr/pollen';
import SectionHeader from './SectionHeader';
import FaqItem from '@/modules/InformationPages/Faq/components/FaqItem.vue';
import ContentfulEntryIDs from '~/lib/global/ContentfulEntryIDs';
import Contentful from '~/services/Contentful';

export default defineComponent({
  components: { BaseButton, FaqItem, SectionHeader },
  setup() {
    const maxItems = ref(5);
    const content = ref({});
    const isLoading = ref(true);
    const faqs = ref([]);
    const { fetch } = useFetch(async () => {
      content.value = await Contentful.getEntry(ContentfulEntryIDs.FAQS);

      isLoading.value = false;
      const items = get(content.value, 'fields.sections', []);
      faqs.value = items.map((item) => {
        const headline = get(item, 'fields.headline');
        const copy = documentToHtmlString(get(item, 'fields.copy'));

        return {
          question: headline,
          answer: copy,
        };
      });
    });

    fetch();

    const show = ref(null);
    const toggle = (index) => {
      if (index === show.value) {
        show.value = null;
      } else {
        show.value = index;
      }
    };

    const updateQty = (value) => {
      if (value === 'max') {
        maxItems.value = faqs.value.length;
      } else {
        maxItems.value = 5;
      }
    };

    onMounted(() => {
      nextTick(() => (show.value = 0));
    });

    return {
      faqs,
      show,
      faqToggle: debounce(toggle, 200),
      updateQty,
      maxItems,
    };
  },
});
</script>
